const textColors = {
  'gray-filled-primary-enabled':
    'rgba(var(--color-text-gray-filled-primary-enabled))',
  'gray-filled-primary-hovered':
    'rgba(var(--color-text-gray-filled-primary-hovered))',
  'gray-filled-primary-selected':
    'rgba(var(--color-text-gray-filled-primary-selected))',
  'gray-filled-secondary-enabled':
    'rgba(var(--color-text-gray-filled-secondary-enabled))',
  'gray-filled-secondary-selected':
    'rgba(var(--color-text-gray-filled-secondary-selected))',
  'gray-filled-tertiary-enabled':
    'rgba(var(--color-text-gray-filled-tertiary-enabled))',
  'gray-filled-tertiary-selected':
    'rgba(var(--color-text-gray-filled-tertiary-selected))',
  'highcontrast-filled-primary-enabled':
    'rgba(var(--color-text-highcontrast-filled-primary-enabled))',
  'highcontrast-filled-secondary-enabled':
    'rgba(var(--color-text-highcontrast-filled-secondary-enabled))',
  'mofidblue-filled-primary-enabled':
    'rgba(var(--color-text-mofidblue-filled-primary-enabled))',
  'mofidblue-filled-primary-selected':
    'rgba(var(--color-text-mofidblue-filled-primary-selected))',
  'mofidblue-filled-secondary-enabled':
    'rgba(var(--color-text-mofidblue-filled-secondary-enabled))',
  'mofidgreen-filled-primary-enabled':
    'rgba(var(--color-text-mofidgreen-filled-primary-enabled))',
  'mofidgreen-filled-primary-selected':
    'rgba(var(--color-text-mofidgreen-filled-primary-selected))',
  'neutral-filled-primary-enabled':
    'rgba(var(--color-text-neutral-filled-primary-enabled))',
  'neutral-filled-secondary-enabled':
    'rgba(var(--color-text-neutral-filled-secondary-enabled))',
  'neutral-filled-tertiary-enabled':
    'rgba(var(--color-text-neutral-filled-tertiary-enabled))',
  'success-filled-primary-enabled':
    'rgba(var(--color-text-success-filled-primary-enabled))',
  'error-filled-primary-enabled':
    'rgba(var(--color-text-error-filled-primary-enabled))',
  'warning-filled-primary-enabled':
    'rgba(var(--color-text-warning-filled-primary-enabled))',
  'link-filled-primary-enabled':
    'rgba(var(--color-text-link-filled-primary-enabled))',
  'success-filled-secondary-enabled':
    'rgba(var(--color-text-success-filled-secondary-enabled))',
  'error-filled-secondary-enabled':
    'rgba(var(--color-text-error-filled-secondary-enabled))',
  'warning-filled-secondary-enabled':
    'rgba(var(--color-text-warning-filled-secondary-enabled))',
  'link-filled-secondary-enabled':
    'rgba(var(--color-text-link-filled-secondary-enabled))',
  'success-filled-tertiary-enabled':
    'rgba(var(--color-text-success-filled-tertiary-enabled))',
  'error-filled-tertiary-enabled':
    'rgba(var(--color-text-error-filled-tertiary-enabled))',
  'warning-filled-tertiary-enabled':
    'rgba(var(--color-text-warning-filled-tertiary-enabled))',
  'link-filled-tertiary-enabled':
    'rgba(var(--color-text-link-filled-tertiary-enabled))',
  'success-tonal-primary-enabled':
    'rgba(var(--color-text-success-tonal-primary-enabled))',
  'error-tonal-primary-enabled':
    'rgba(var(--color-text-error-tonal-primary-enabled))',
  'warning-tonal-primary-enabled':
    'rgba(var(--color-text-warning-tonal-primary-enabled))',
  'link-tonal-primary-enabled':
    'rgba(var(--color-text-link-tonal-primary-enabled))',
  'purple-filled-primary-enabled':
    'rgba(var(--color-text-purple-filled-primary-enabled))',
  'purple-filled-primary-hovered':
    'rgba(var(--color-text-purple-filled-primary-hovered))',
};

export default textColors;
